import { h } from 'preact';

type Props = {
  size?: number;
  id?: string;
  customStyle?: h.JSX.CSSProperties;
  color?: string;
};

export default function CrossCloseSvg({
  id,
  size = 16,
  customStyle = {},
  color = 'white'
}: Props) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      style={customStyle}
    >
      <path
        d="M21,6.611,19.389,5,13,11.389,6.611,5,5,6.611,11.389,13,5,19.389,6.611,21,13,14.611,19.389,21,21,19.389,14.611,13Z"
        transform="translate(-5 -5)"
        fill={color}
      />
    </svg>
  );
}
